angular.module('util.MapModule').service('trsBaiduMapService', [
    'trsHttpService',
    '$q',
    function(trsHttpService, $q) {
        return {
            createMap: createMap, // 获取地图实例
            createPoint: createPoint, // 创建点坐标
            location: location, // 定位当前地点
            createComplete: createComplete, // 创建检索自动完成功能
            getCompleteResult: getCompleteResult, // 获取自动完成结果
            createGeoCoder: createGeoCoder, // 创建地理位置对象
            getAddressName: getAddressName, // 获取地址名称
            getSinaAddressList: getSinaAddressList, // 获取新浪地址库地址
            setMarker: setMarker, // 标注地点
            Wgs84Tobd09: Wgs84Tobd09, // 新浪地址转百度地址
            getGaodeAddressList: getGaodeAddressList, // 获取高德地址库POI地址
        };

        /**
         * [getMap 获取地图实例]
         *
         * @param   {[type]}  containerId  [地图容器ID]
         *
         * @return  {[type]}               [return description]
         */
        function createMap(containerId) {
            let map = new BMap.Map(containerId, { enableMapClick: false });
            return map;
           
        }

        /**
         * [createPoint 创建点坐标]
         *
         * @param   {[type]}  point  [点坐标对象]
         *
         * @return  {[type]}         [return description]
         */
        function createPoint(point) {
            let newPoint = new BMap.Point(point.lng, point.lat);
            return newPoint;
        }

        /**
         * [location 定位到当前地点]
         *
         * @param   {[type]}  success  [定位后要执行的方法]
         *
         * @return  {[type]}       [return description]
         */
        function location(success) {
            let curCity = new BMap.LocalCity();
            curCity.get(success);
        }

        /**
         * [createComplete 创建自动完成实例]
         *
         * @param   {[type]}  options  [options description]
         *
         * @return  {[type]}           [return description]
         */
        function createComplete(options) {
            let autoComplete = new BMap.Autocomplete(options);
            return autoComplete;
        }

        /**
         * [getCompleteResult 获取自动完成结果]
         *
         * @param   {[type]}  e  [e description]
         *
         * @return  {[type]}     [return description]
         */
        function getCompleteResult(e) {
            const _value = e.item.value;
            const myValue = getAddressName(_value);
            return myValue;
        }

        /**
         * [getAddressName 获取地址名称]
         *
         * @param   {[type]}  value  [value 地址对象]
         *
         * @return  {[type]}         [return description]
         */
        function getAddressName(value) {
            let _value = value;
            const myValue = _value.province + _value.city + _value.district + _value.street + _value.business;

            return myValue;
        }

        /**
         * [创建地理位置对象]
         */
        function createGeoCoder() {
            let gc = new BMap.Geocoder();
            return gc;
        }

        /**
         * [getSinaAddressList 获取新浪地址库]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getSinaAddressList(params) {
            let deferred = $q.defer();
            let point = {
                lng: params.jd,
                lat: params.wd,
            };
            point = bd09ToWgs84(point);
            params.jd = point.lng;
            params.wd = point.lat;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deferred.resolve(data);
            }, function(data){
                deferred.reject(data);
            });
            return deferred.promise;
        }

        /**
         * [getGaodeAddressList 获取高德地址库地址]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getGaodeAddressList(params) {
            let deferred = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deferred.resolve(data);
            }, function(data){
                deferred.reject(data);
            });
            return deferred.promise;
        }

        /**
         * [bd09ToWgs84 百度坐标转WGS84坐标]
         *
         * @param   {[type]}  point  [point description]
         *
         * @return  {[type]}         [return description]
         */
        function bd09ToWgs84(point){
            let GCJ02 = bd09ToGcj02(point.lng, point.lat);
            let WGS84 = gcj02ToWgs84(GCJ02[0], GCJ02[1]);
            return {
                lng: WGS84[0], 
                lat: WGS84[1],
            };
        }

        /**
         * [Wgs84Tobd09 wgs84坐标转百度坐标]
         *
         * @param   {[type]}  point  [point description]
         *
         * @return  {[type]}         [return description]
         */
        function Wgs84Tobd09(point){
            let bd09 = gcj02tobd09(point.lng, point.lat);
            return {
                lng: bd09[0], 
                lat: bd09[1],
            };
        }

        /**
         * [bd09togcj02 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换,即 百度 转 谷歌、高德]
         *
         * @param   {[type]}  bd_lon  [bd_lon description]
         * @param   {[type]}  bd_lat  [bd_lat description]
         *
         * @return  {[type]}          [return description]
         */
        function bd09ToGcj02(bd_lon, bd_lat) {
            var x_pi = (3.14159265358979324 * 3000.0) / 180.0;
            var x = bd_lon - 0.0065;
            var y = bd_lat - 0.006;
            var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
            var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
            var gg_lng = z * Math.cos(theta);
            var gg_lat = z * Math.sin(theta);
            return [gg_lng, gg_lat];
        }

        /**
         * [gcj02tobd09 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换,即谷歌、高德 转 百度]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function gcj02tobd09(lng, lat) {
            var x_PI = (3.14159265358979324 * 3000.0) / 180.0;
            var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
            var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
            var bd_lng = z * Math.cos(theta) + 0.0065;
            var bd_lat = z * Math.sin(theta) + 0.006;
            return [bd_lng, bd_lat];
        }

        /**
         * [wgs84togcj02 WGS84转GCj02]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function wgs84togcj02(lng, lat) {
            var PI = 3.1415926535897932384626;
            var a = 6378245.0;
            var ee = 0.00669342162296594323;
            if (outOfChina(lng, lat)) {
                return [lng, lat];
            } else {
                var dlat = transformlat(lng - 105.0, lat - 35.0);
                var dlng = transformlng(lng - 105.0, lat - 35.0);
                var radlat = (lat / 180.0) * PI;
                var magic = Math.sin(radlat);
                magic = 1 - ee * magic * magic;
                var sqrtmagic = Math.sqrt(magic);
                dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
                dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
                var mglat = lat + dlat;
                var mglng = lng + dlng;
                return [mglng, mglat];
            }
        }

        /**
         * [gcj02towgs84 GCJ02 转换为 WGS84]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function gcj02ToWgs84(lng, lat) {
            // 定义一些常量
            var PI = 3.1415926535897932384626;
            var a = 6378245.0;
            var ee = 0.00669342162296594323;

            if (outOfChina(lng, lat)) {
                return [lng, lat];
            } else {
                var dlat = transformlat(lng - 105.0, lat - 35.0);
                var dlng = transformlng(lng - 105.0, lat - 35.0);
                var radlat = (lat / 180.0) * PI;
                var magic = Math.sin(radlat);
                magic = 1 - ee * magic * magic;
                var sqrtmagic = Math.sqrt(magic);
                dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
                dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
                var mglat = lat + dlat;
                var mglng = lng + dlng;
                return [lng * 2 - mglng, lat * 2 - mglat];
            }
        }

        /**
         * [transformlat 转换精度]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function transformlat(lng, lat) {
            var PI = 3.1415926535897932384626;
            var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
            ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
            ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
            ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
            return ret;
        }

        /**
         * [transformlng 转换维度]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function transformlng(lng, lat) {
            var PI = 3.1415926535897932384626;
            var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
            ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
            ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
            ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
            return ret;
        }

        /**
         * [outOfChina 判断是否在国内，不在国内则不做偏移]
         *
         * @param   {[type]}  lng  [lng description]
         * @param   {[type]}  lat  [lat description]
         *
         * @return  {[type]}       [return description]
         */
        function outOfChina(lng, lat) {
            return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false;
        }

        /**
         * [setMarker 标注地点]
         *
         * @param   {[type]}  point  [point description]
         *
         * @return  {[type]}         [return description]
         */
        function setMarker(map, point) {
            map.clearOverlays();
            var marker = new BMap.Marker(point); // 创建标注    
            map.addOverlay(marker);
        }
    },
]);
